
<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="d-flex mb-4">
        <h2>{{ $t("mySchdl.addNewEventActivity") }}</h2>
        <v-spacer></v-spacer>
        <v-btn
          depressed
          outlined
          color="primary"
          class="mr-2"
          @click="cancelTask"
        >
          {{ $t("actionListmod.cANCEL") }}
        </v-btn>
        <v-btn depressed color="primary" class="" @click="createTask">
          {{ $t("save") }}
        </v-btn>
      </div>

      <v-card elevation="0" class="py-5">
        <v-card-text>
          <v-form
            @submit.prevent="createTask"
            ref="taskForm"
            v-model="valid"
            lazy-validation
          >
            <v-row class="py-0">
              <v-col cols="4" class="py-0">
                <div class="subtitle black--text">
                  {{ $t("Title") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.titleTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-text-field
                  :placeholder="$t('Type the activity/event title here')"
                  v-model="Task.title"
                  :error-messages="errors.title"
                  :rules="taskRules.title"
                  outlined
                  dense
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col cols="4" class="py-0">
                <div class="subtitle black--text">
                  {{ $t("Type") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.typeTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-select
                  :items="types"
                  item-text="name"
                  item-value="id"
                  outlined
                  dense
                  placeholder="Select from the dropdown"
                  v-model="Task.moduleId"
                  :rules="taskRules.type"
                  @change="moduleChanged"
                ></v-select>
              </v-col>
              <v-col
                cols="4"
                class="py-0"
                v-if="selectedModule.operationName == 'animal'"
              >
                <div class="subtitle black--text">
                  {{ $t("Select Animal") }}
                </div>
                <v-menu
                  v-model="animalMenu"
                  :close-on-content-click="false"
                  :nudge-width="100"
                  offset-y
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="selectedAnimalAndgroup"
                      outlined
                      readonly
                      dense
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-card>
                    <v-tabs v-model="animaltab" centered grow>
                      <v-tab>{{ $t("singleAnimal") }}</v-tab>
                      <v-tab>{{ $t("groupOfAnimals") }}</v-tab>
                    </v-tabs>
                    <v-tabs-items v-model="animaltab">
                      <v-tab-item>
                        <v-card>
                          <v-card-text>
                            <v-text-field
                              v-model="searchQuery"
                              outlined
                              dense
                            ></v-text-field>
                            <v-card
                              flat
                              max-height="200"
                              style="overflow-y: scroll"
                            >
                              <v-card-text class="pa-0">
                                <v-list-item-group>
                                  <v-list-item
                                    v-for="a in filteredAnimals"
                                    :key="a.id"
                                  >
                                    <v-list-item-action>
                                      <v-checkbox
                                        color="primary accent-4"
                                        v-model="Task.taskForAnimals"
                                        :value="a.id"
                                      ></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                      <v-list-item-title>{{
                                        `${a.id}(${a.speciesType?.name})`
                                      }}</v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                      <v-tab-item>
                        <v-card>
                          <v-card-text>
                            <v-text-field
                              v-model="searchQueryGroup"
                              outlined
                              dense
                            ></v-text-field>
                            <v-card
                              flat
                              max-height="200"
                              style="overflow-y: scroll"
                            >
                              <v-card-text class="pa-0">
                                <v-list-item-group>
                                  <v-list-item
                                    v-for="a in filteredGroups"
                                    :key="a.id"
                                  >
                                    <v-list-item-action>
                                      <v-checkbox
                                        color="primary accent-4"
                                        v-model="Task.taskForAnimalGroups"
                                        :value="parseInt(a.id)"
                                      ></v-checkbox>
                                    </v-list-item-action>
                                    <v-list-item-content>
                                      <v-list-item-title
                                        v-text="a.name"
                                      ></v-list-item-title>
                                    </v-list-item-content>
                                  </v-list-item>
                                </v-list-item-group>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                        </v-card>
                      </v-tab-item>
                    </v-tabs-items>
                  </v-card>
                </v-menu>
              </v-col>
              <!-- <v-col cols="4" class="py-0" v-if="selectedModule.operationName == 'farm'">
								<div class="subtitle">{{$t('Event /Activity For')}}</div>
									<v-select
										:items="[{id: farm.id, name: farm.farmName}]"
										item-text="name"
										item-value="id"
										outlined
										dense
										placeholder="Select the module and submodule"
										v-model="Task.taskForFarm"
										readonly

									></v-select>
							</v-col> -->
            </v-row>

            <v-row class="py-0">
              <v-col cols="4">
                <div class="subtitle black--text">
                  {{ $t("actionListmod.startDate") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.startDateTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-menu
                  v-model="startDateModel"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Task.startDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      :error-messages="errors.startDate"
                      :rules="taskRules.startDate"
                      placeholder="Start Date & Time"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="startDate"
                    :min="nowDate"
                    no-title
                    width="500"
                  >
                    <div class="content-bar">
                      <div class="times">
                        <h2>{{ $t("times") }}</h2>
                        <div class="all-day-check">
                          <input
                            v-model="allDay"
                            type="checkbox"
                            aria-label="Checkbox for following text input"
                          />
                          <h2>All Day</h2>
                        </div>
                      </div>
                      <div class="time-section">
                        <div class="time-1">
                          <input
                            :disabled="allDay"
                            type="number"
                            v-model="startHour"
                            min="01"
                            max="12"
                          />
                        </div>
                        <p style="margin: 0px 12px">:</p>
                        <div class="time-1 margin-right-1">
                          <input
                            :disabled="allDay"
                            type="number"
                            v-model="startMinute"
                            min="00"
                            max="60"
                          />
                        </div>
                        <v-btn-toggle tile color="primary" v-model="timeSet">
                          <v-btn value="AM"> AM </v-btn>

                          <v-btn value="PM"> PM </v-btn>
                        </v-btn-toggle>
                      </div>
                      <v-btn
                        text
                        depressed
                        color="primary"
                        class="cofirm-btn"
                        @click="startDateSelected"
                        >Confirm</v-btn
                      >
                    </div>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <div class="subtitle black--text">
                  {{ $t("actionListmod.endDate") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.endDateTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-menu
                  v-model="endDateModel"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="Task.endDate"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      dense
                      :error-messages="errors.endDate"
                      :rules="taskRules.endDate"
                      placeholder="End Date & Time"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="endDate"
                    :min="nowDate"
                    no-title
                    width="500"
                  >
                    <div class="content-bar">
                      <div class="times">
                        <h2>{{ $t("times") }}</h2>
                        <div class="all-day-check">
                          <input
                            v-model="allDay"
                            type="checkbox"
                            aria-label="Checkbox for following text input"
                          />
                          <h2>All Day</h2>
                        </div>
                      </div>
                      <div class="time-section">
                        <div class="time-1">
                          <input
                            :disabled="allDay"
                            type="number"
                            v-model="endHour"
                            min="01"
                            max="12"
                          />
                        </div>
                        <p style="margin: 0px 12px">:</p>
                        <div class="time-1 margin-right-1">
                          <input
                            :disabled="allDay"
                            type="number"
                            v-model="endMinute"
                            min="00"
                            max="60"
                          />
                        </div>
                        <v-btn-toggle tile color="primary" v-model="timeSet">
                          <v-btn value="AM"> AM </v-btn>

                          <v-btn value="PM"> PM </v-btn>
                        </v-btn-toggle>
                      </div>
                      <v-btn
                        text
                        depressed
                        color="primary"
                        class="cofirm-btn"
                        @click="endDateSelected"
                        >Confirm</v-btn
                      >
                    </div>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="4">
                <div class="subtitle black--text">
                  {{ $t("Category") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.categoryTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-select
                  :items="categories"
                  outlined
                  dense
                  item-text="name"
                  item-value="id"
                  v-model="Task.taskCategoryId"
                  :error-messages="errors.taskCategoryId"
                  :rules="taskRules.taskCategoryId"
                  placeholder="Select from the dropdown"
                ></v-select>
              </v-col>
              <v-col cols="12" class="mt-n5">
                <div class="subtitle black--text">
                  {{ $t("actionListmod.dESCRIPTION") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.descriptionTooltip") }}
                    </span>
                  </v-tooltip>
                </div>
                <v-textarea
                  outlined
                  name="input-7-4"
                  :placeholder="$t('actionListmod.enterDescription')"
                  v-model="Task.description"
                  :error-messages="errors.description"
                ></v-textarea>
              </v-col>
            </v-row>
            <v-row class="py-0">
              <v-col cols="4" class="">
                <div class="subtitle black--text">
                  {{ $t("actionListmod.rEPEAT") }}
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.repeatTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-select
                  :items="repeatOptions"
                  outlined
                  dense
                  item-text="name"
                  item-value="id"
                  v-model="Task.repeatMasterId"
                  @change="repeatChanged"
                  :error-messages="errors.repeatMasterId"
                  :rules="taskRules.repeatMasterId"
                  placeholder="Select from the dropdown"
                ></v-select>
              </v-col>
              <!-- <v-col cols="4" class="">
								<div class="subtitle">{{$t('Event / Activity Color')}}</div>
								<v-select
								:items="colorsList"
								outlined
								dense
								item-text="name"
								item-value="id"
								v-model="Task.eventActivityColorId"
								:error-messages="errors.eventActivityColorId"
								:rules="taskRules.eventActivityColorId"
								></v-select>
							</v-col> -->
              <v-col cols="4" class="">
                <div class="subtitle black--text">
                  Status
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.statusTooltip") }}
                    </span>
                  </v-tooltip>
                  *
                </div>
                <v-select
                  :items="statusList"
                  outlined
                  dense
                  item-text="name"
                  item-value="id"
                  v-model="Task.status"
                  :error-messages="errors.status"
                  :rules="taskRules.status"
                  placeholder="To-Do"
                ></v-select>
              </v-col>
              <v-col cols="4" class="">
                <div class="subtitle black--text">
                  Priority
                  <v-tooltip top color="black" max-width="350">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on">
                        mdi-help-circle-outline
                      </v-icon>
                    </template>
                    <span>
                      {{ $t("actionListmod.pRIORITY") }}
                    </span>
                  </v-tooltip>
                </div>
                <v-select
                  :items="['High', 'Low']"
                  outlined
                  dense
                  v-model="Task.priority"
                  item-text="name"
                  placeholder="High"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4" class="">
                <v-checkbox v-model="Task.addEventToCalendar">
                  <template v-slot:label>
                    <span class="black--text">{{
                      $t("mySchdl.addEventMyCalendar")
                    }}</span>
                  </template>
                </v-checkbox>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-container>
    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
    </v-snackbar>
    <RepeatDialouge
      :dialog="dialog"
      v-if="dialog"
      @modal-closed="repeatDialougeClosed"
      @repeat-settings-saved="customRepeatSettings"
    />

    <prompt-dialog
      @closeDialog="showPromptDialog = false"
      @saveData="saveFormData"
      :dialogI="showPromptDialog"
      v-if="showPromptDialog"
    />
  </div>
</template>
<script>
import loading from "@/mixins/LoadingMixin";
import moment from "moment";
import { getAnimals, animalGroups } from "@/graphql/Animals.gql";
import FarmService from "@/_services/farmService";
import RepeatDialouge from "./RepeatDialouge.vue";

import { createTask, getDropDownDataForTask } from "@/graphql/ActionLists.gql";
import PromptDialog from "../common/PromptDialog.vue";
import _ from "lodash";
export default {
  apollo: {
    getDropDownDataForTask: {
      query: getDropDownDataForTask,
      result({ data }) {
        this.types = data.getDropDownDataForTask.modules;
        this.activityForList = data.getDropDownDataForTask.modules;
        this.categories = data.getDropDownDataForTask.taskCategory;
        this.repeatOptions = data.getDropDownDataForTask.repeatMaster;
        this.colorsList = data.getDropDownDataForTask.eventActivityColors;
      },
    },
    animals: {
      query: getAnimals,
      variables: {
        categoryId: null,
        search: "",
        byGroup: null,
        type: null,
        page: 1,
        limit: 500,
      },
      update: (data) => {
        return data.generalInformations.rows;
      },
      result({ data }) {
        console.log("animals Data", data);
      },
    },
    groups: {
      query: animalGroups,
      update: (data) => {
        return data.groups.groupData;
      },
      result({ data }) {
        console.log("groups", data);
      },
    },
  },
  components: {
    "prompt-dialog": PromptDialog,
    RepeatDialouge,
  },
  beforeRouteLeave(to, from, next) {
    if (this.promptNextRoute) {
      next();
    } else {
      if (this.hasChanged) {
        this.promptToRoute = to;
        this.showPromptDialog = true;
      } else {
        next();
      }
    }
  },
  async mounted() {
    const animalId = this.$route.params.animalId;
    if(animalId){
      this.Task.taskForAnimals = [animalId];
    }
    this.defaultData = { ...this.Task };
    document.title = this.$t("mySchdl.mySchedulecreateTask");
    this.startLoading();
    const { data } = await FarmService.getPrimaryFarm();
    this.stopLoading();
    if (_.isEmpty(data)) {
      this.$notify({
        title: this.$t("mySchdl.pleaseRegisterPrimaryFarm"),
        text: "",
        type: "error",
      });
      return;
    }
    this.farm = data;
  },
  computed: {
    hasChanged() {
      return Object.keys(this.Task).some(
        (field) => this.Task[field] !== this.defaultData[field]
      );
    },
    computedDateFormattedMomentjs() {
      return this.today ? moment(this.today).format("MMMM YYYY") : "";
    },
    selectedAnimalAndgroup() {
      return [...this.Task.taskForAnimalGroups, ...this.Task.taskForAnimals];
    },
    filteredAnimals() {
      // Filter the animals based on the search query
      return this.animals.filter((a) => a.id.includes(this.searchQuery));
    },
    filteredGroups() {
      // Filter the groups based on the search query
      return this.groups.filter((a) => a.name.includes(this.searchQueryGroup));
    },
  },
  watch: {
    startHour: {
      handler(v) {
        this.startHour = ("0" + v).slice(-2);
      },
      deep: true,
    },
    startMinute: {
      handler(v) {
        this.startMinute = ("0" + v).slice(-2);
      },
      deep: true,
    },
    endHour: {
      handler(v) {
        this.endHour = ("0" + v).slice(-2);
      },
      deep: true,
    },
    endMinute: {
      handler(v) {
        this.endMinute = ("0" + v).slice(-2);
      },
      deep: true,
    },
  },
  data() {
    return {
      statusList: ["To-Do", "Pending"],
      animalMenu: false,
      animaltab: 0,
      selectedAnimals: [],
      animalType: "group",
      selectedModule: {},
      types: [],
      activityForList: [],
      categories: [],
      repeatOptions: [],
      colorsList: [],
      startHour: "00",
      startMinute: "00",
      timeSet: "AM",
      endHour: "00",
      endMinute: "00",
      endTimeSet: "AM",
      allDay: false,
      farm: null,
      Task: {
        title: "",
        moduleId: null,
        taskForFarm: null,
        taskForAnimals: [],
        taskForAnimalGroups: [],
        startDate: "",
        endDate: "",
        taskCategoryId: null,
        description: "",
        repeatMasterId: null,
        customSettings: {},
        //eventActivityColorId: null,
        addEventToCalendar: false,
        status: "",
      },
      valid: true,
      dialog: false,
      errors: {
        name: "",
        startDate: "",
        dueDate: "",
        priority: "",
        description: "",
        assignees: "",
        locations: "",
        animals: "",
        repeats: "",
        status: "",
      },
      taskRules: {
        title: [(v) => !!v || "Task title is required"],
        startDate: [(v) => !!v || "Start date is required"],
        endDate: [(v) => !!v || "End date is required"],
        type: [(v) => !!v || "Type is required"],
        description: [(v) => !!v || "Description is required"],
        time: [(v) => !!v || "Time is required"],
        taskCategoryId: [(v) => !!v || "Category is required"],
        //eventActivityColorId: [(v) => !!v || "Color ID is required"],
        repeatMasterId: [(v) => !!v || "Repeat type is required"],
        status: [(v) => !!v || "Status title is required"],
      },
      snackbarText: "",
      snackbar: false,
      repeatDay: 0,
      startDateModel: false,
      endDateModel: false,
      nowDate: new Date().toISOString().slice(0, 10),
      startDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      endDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      repeat: "",
      animals: null,
      selected: null,
      animalLoading: false,
      animalSearch: "",
      farms: [],
      time: "",
      category: "",
      assignees: null,
      status: "active",
      description: "",
      repeatWeekDays: [],
      repeatEndValue: "",
      repeatsInterval: "",
      repeatsFreq: "",
      repeatEnds: "",
      onValue: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      afterValue: "",
      active: false,
      breadcrumbs: [
        {
          text: this.$t("dashboard"),
          disabled: false,
          to: "/",
        },
        {
          text: this.$t("My Schedule"),
          disabled: false,
          to: { name: "ActionList" },
          exact: true,
        },
        {
          text: this.$t("Create Task"),
          disabled: true,
        },
      ],
      showPromptDialog: false,
      promptToRoute: null,
      promptNextRoute: false,
      defaultData: {},
      searchQuery: "",
      searchQueryGroup: "",
    };
  },
  methods: {
    repeatDialougeClosed() {
      this.dialog = false;
      this.Task.repeatMasterId = null;
    },
    customRepeatSettings(data) {
      this.dialog = false;
      this.Task.customSettings = data;

      console.log(this.Task);
    },
    moduleChanged(e) {
      this.selectedModule = this.types[e - 1];
      if (this.selectedModule.operationName == "animal")
        this.Task.taskForFarm = null;
      else if (this.selectedModule.operationName == "farm") {
        this.Task.taskForAnimals = [];
        this.Task.taskForAnimalGroups = [];
        this.Task.taskForFarm = parseInt(this.farm.id);
      } else {
        this.Task.taskForFarm = null;
        this.Task.taskForAnimals = [];
        this.Task.taskForAnimalGroups = [];
      }
    },
    saveFormData(answer) {
      this.showPromptDialog = false;
      if (!answer) {
        this.promptNextRoute = true;
        this.$router.push(this.promptToRoute);
      }
    },
    startDateSelected() {
      var hour = parseInt(this.startHour);
      if (this.timeSet == "PM" && hour < 12) hour = hour + 12;
      if (this.timeSet == "AM" && hour == 12) hour = hour - 12;
      this.Task.startDate = `${this.startDate} ${("0" + hour).slice(-2)}:${
        this.startMinute
      }:00`;
      this.startDateModel = false;
    },

    endDateSelected() {
      var hour = parseInt(this.endHour);
      if (this.timeSet == "PM" && hour < 12) hour = hour + 12;
      if (this.timeSet == "AM" && hour == 12) hour = hour - 12;
      this.Task.endDate = `${this.endDate} ${("0" + hour).slice(-2)}:${
        this.endMinute
      }:00`;
      this.endDateModel = false;
    },

    setactive(val) {
      this.active = val;
    },

    repeatChanged(e) {
      let x = this.repeatOptions[e - 1];

      if (x.name.toLowerCase() == "custom") {
        this.dialog = true;
      }
    },
    createTask() {
      if (!this.$refs.taskForm.validate()) return;
      this.startLoading();
      this.Task.moduleId = parseInt(this.Task.moduleId);
      this.Task.taskCategoryId = parseInt(this.Task.taskCategoryId);
      this.Task.repeatMasterId = parseInt(this.Task.repeatMasterId);
      //this.Task.eventActivityColorId = parseInt(this.Task.eventActivityColorId);

      if (this.Task.taskForAnimals.length) {
        this.Task.taskForAnimals = this.Task.taskForAnimals.map((e) => {
          e = parseInt(e);
          return e;
        });
      }
      this.$apollo
        .mutate({
          mutation: createTask,
          variables: {
            createTaskInput: this.Task,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.status == 422) {
            res.data.message.errors.forEach((em) => {
              this.errors[em.param] = em.msg;
            });
          } else {
            this.$notify({
              title: "Task created successfully ",
              text: "",
              type: "success",
            });
            this.promptNextRoute = true;
            this.$router.push({ name: "ActionList" });
          }
        })
        .catch((err) => {
          console.log("err", err.response);
        })
        .finally(() => {
          this.stopLoading();
        });
    },
    cancelTask() {
      this.$router.push({ name: "ActionList" });
    },

    next() {
      // this.$refs.calendar.next()
      var myPastDate = new Date(this.today);
      myPastDate.setMonth(myPastDate.getMonth() + 1);
      let month = `${myPastDate.getMonth() + 1}`;

      if (myPastDate.getMonth() + 1 < 10) {
        month = "0" + month;
      }
      this.today =
        myPastDate.getFullYear() + "-" + month + "-" + myPastDate.getDate();
    },
  },
  mixins: [loading],
};
</script>
<style lang="scss">
.activeClass {
  background-color: olive !important;
}

.content-bar {
  width: 45%;
  margin: 0 auto;
  text-align: center;
}

.times {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.times h2 {
  font-size: 15px;
}

.all-day-check {
  display: flex;
  align-items: center;
}

.all-day-check input {
  margin-right: 7px;
}

.time-1 input {
  background: #e9e9e9;
  width: 55px;
  height: 28px;
  padding: 4px 6px;
  outline: none !important;
}

.time-section {
  margin-top: 7px;
  display: flex;
}

.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 28px !important;
  padding: 0px 0px !important;
}

.margin-right-1 {
  margin-right: 12px;
}

button.v-btn.v-item--active.v-btn--active.v-btn--is-elevated.v-btn--has-bg.theme--light.v-size--default {
  background: #0ebf67;
  color: #fff;
}

.v-btn-toggle .v-btn.v-btn.v-size--default {
  min-width: 40px;
  min-height: 0;
}

button.cofirm-btn {
  padding: 0px 0px !important;
  display: inline-block;
  text-align: center;
  margin-top: 10px;
}
</style>
